<template>
  <v-app :style="[cssVars]" class="app-background-color">
    <template v-if="!isHide">
      <UIMenu
        v-if="!isSmAndDown && computedLinks.length"
        :links="computedLinks"
      />
    </template>

    <TheNavbar
      :links="computedLinks"
      :is-sm-and-down="isSmAndDown"
      :is-xs="isXs"
      @openHelpDialog="helpDialog = true"
    />
    <v-main class="main" :class="[{'mobile': isSmAndDown}, isXs ? 'mr-4' : 'mr-10' , isXs ? 'ml-4' : isHide ? 'ml-10' : 'ml-15']">
            <router-view :is-sm-and-down="isSmAndDown" />
    </v-main>
    
    <TheFooter />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import TheNavbar from '@/components/Spm/App/TheNavbar'
import UIMenu from '@/ui/UIMenu'
import TheFooter from '@/components/Spm/App/TheFooter'

export default {
  name: 'App',

  components: {
    TheFooter,
    UIMenu,
    TheNavbar,
  },

  async created() {
    this.hideHtmlOverflow()
  },

  async mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },

  destroyed() {
    this.showHtmlOverflow()
    window.removeEventListener('resize', this.onResize)
  },

  data: () => ({
    isSmAndDown: false,
    isXs: false,
    helpDialog: false,

    links: [
      {
        id: 1,
        icon: 'user',
        text: 'Личные данные',
        route: '/spm/personalData',
        allowRoles: ['ROLE_ADMIN', 'ROLE_OPERATOR', 'ROLE_USER'],
        linksSwitcher: false,
      },
      {
        id: 1,
        icon: 'book-open',
        text: 'Мероприятия',
        route: '/spm/events',
        allowRoles: ['ROLE_ADMIN', 'ROLE_OPERATOR', 'ROLE_USER'],
        linksSwitcher: false,
      },
      {
        id: 2,
        icon: 'file-text',
        text: 'Мои формы',
        route: '/spm/myFilledForms',
        allowRoles: ['ROLE_ADMIN', 'ROLE_OPERATOR', 'ROLE_USER'],
        linksSwitcher: false,
      },
      {
        id: 3,
        icon: 'info-icon',
        text: 'Новости',
        route: '/spm/news',
        allowRoles: ['ROLE_ADMIN', 'ROLE_OPERATOR', 'ROLE_USER'],
        linksSwitcher: false,
      },
      {
        id: 4,
        icon: 'sliders',
        text: 'Управление справочниками',
        route: '/spm/directories',
        allowRoles: ['ROLE_ADMIN'],
        linksSwitcher: false,
      },

      {
        id: 5,
        icon: 'status-list',
        text: 'Назначение статусов',
        url: process.env.VUE_APP_GRAPH_URL,
        allowRoles: ['ROLE_ADMIN'],
        linksSwitcher: false,
      },
    ],
  }),

  computed: {
    ...mapGetters('system', ['techMessageHeight']),
    ...mapGetters('user', ['userId', 'allUserRoles', 'isAdmin']),

    computedLinks() {
      if (!this.userId) return []

      return this.links.filter((link) => link.allowRoles.some((role) => this.allUserRoles.includes(role)))
    },

    isHide() {
      return ['userParent', 'roleParent', 'userGroupParent', 'login',
        'formConstructor', 'fillingForm', 'fillingFormForAdmin', 'forget',
        'registration', 'registrationConfirm', 'forgetConfirm'].includes(this.$route.name)
    },

    isHideNewsLine() {
      return ['newsPage', 'userParent', 'roleParent', 'userGroupParent', 'login', 'formConstructor', 'fillingForm',
        'fillingFormForAdmin', 'forget', 'registration', 'registrationConfirm', 'forgetConfirm', 'directories',
        'actionPage', 'eventTypePartPage', 'locationPage'].includes(this.$route.name)
    },

    cssVars() {
      return { '--tech-message-height': `${this.techMessageHeight}px` }
    },
  },

  methods: {
    onResize() {
      this.isSmAndDown = window.innerWidth < 960
      this.isXs = window.innerWidth < 620
    },

    hideHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'hidden'
    },

    showHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'visible'
    },
  },
}
</script>
